import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormArray, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { InputNumberModule } from 'primeng/inputnumber';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';

export interface ProductOption {
  label: string;
  value: number;
  priceCost: number;
  code: string;
  description: string;
  measureUnityId: number;
}

@Component({
  selector: 'app-step-produtos',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    DropdownModule,
    InputNumberModule,
    ButtonModule,
    TableModule,
    TooltipModule
  ],
  templateUrl: './step-produtos.component.html'
})
export class StepProdutosComponent {
  @Input() parentForm!: FormGroup;
  @Input() productOptions: ProductOption[] = [];
  @Output() filterChange = new EventEmitter<string>();
  @Output() requestNewProduct = new EventEmitter<void>();

  get itemsArray(): FormArray {
    return this.parentForm?.get('items') as FormArray;
  }

  get totalProductsFormatted(): string {
    const arr = this.itemsArray;
    if (!arr) return '0,00';
    const total = arr.controls.reduce((sum, c) => {
      const g = c as FormGroup;
      const q = Number(g.get('quantity')?.value) || 0;
      const u = Number(g.get('unitPrice')?.value) || 0;
      const d = Number(g.get('discount')?.value) || 0;
      return sum + (q * u - d);
    }, 0);
    return total.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  onProductFilter(event: { filter?: string }): void {
    this.filterChange.emit((event?.filter ?? '').trim());
  }

  onProductSelect(index: number, event: { value: number }): void {
    const opt = this.productOptions.find(o => o.value === event.value);
    if (opt) {
      this.itemsArray.at(index).patchValue({
        unitPrice: opt.priceCost,
        productCode: opt.code,
        productDescription: opt.description
      });
    }
  }

  addItem(): void {
    this.itemsArray.push(
      new FormGroup({
        productId: new FormControl<number | null>(null),
        productCode: new FormControl<string>(''),
        productDescription: new FormControl<string>(''),
        quantity: new FormControl<number>(1),
        unitPrice: new FormControl<number>(0),
        discount: new FormControl<number>(0)
      })
    );
  }

  removeItem(index: number): void {
    this.itemsArray.removeAt(index);
  }

  getRowTotal(row: FormGroup): string {
    const q = Number(row.get('quantity')?.value) || 0;
    const u = Number(row.get('unitPrice')?.value) || 0;
    const d = Number(row.get('discount')?.value) || 0;
    return (q * u - d).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
}
